export default {
    activated: 'Activated',
    active: 'Active',
    applyAndReload: 'Apply and reload',
    autoActivated: 'Auto-activated',
    availableSince: 'Available since {0}',
    browserNotSupportingVideoPlaying: 'Your browser does not support video playing.',
    deactivateWithoutComment: 'Deactivate without comment',
    deactivated: 'Deactivated',
    giveFeedback: 'Give feedback',
    leaveAComment: 'Leave a comment',
    newTag: 'New',
    noComment: 'No comment',
    notAutoActivated: 'Not auto-activated',
    projectedAdoptionOn: 'Projected adoption on {0}',
    requestFeedback: 'Before disabling {0}, would you like to give us your feedback?',
    theF: 'the',
    theM: 'the',
    title: 'Feature Previews',
    willBe: 'Will be',
    newLeadPage: {
        description1:
            'We are excited to announce a major update to the Lead Page. We have completely revamped this page to make it more user-friendly and efficient.',
        description2: 'Some of the key changes include:',
        change1: 'A new layout that is more intuitive and easier to navigate',
        change2: 'Enhanced filtering functionality',
        change3: 'New visual elements and design updates',
        change4: 'And much more...',
        conclusion:
            'We hope these changes will make it easier for you to find and manage your leads. Please let us know if you have any feedback or questions about this update. Thank you for using Activix CRM!',
    },
    leadPageV3: {
        description1: 'Lead Page V3 with combined sales progress.',
        description2: 'This will automatically enable the New lead page on which the V3 depends.',
    },
};
